﻿import {createContext, JSX, ReactNode, useContext, useMemo, useState} from "react";

interface FilteredItemsContextType<T> {
	source: T[];
	filtered: T[];
	setFiltered: (filtered: T[]) => void;
}

const FilteredItemsContext = createContext<FilteredItemsContextType<any> | null>(null);

interface FilteredItemsProviderProps<T> {
	children: ReactNode;
	items: T[];
}

export function FilteredItemsProvider<T>(props: FilteredItemsProviderProps<T>): JSX.Element {
	const {children, items} = props;
	const [filteredItems, setFilteredItems] = useState<T[]>(() => items);

	const value = useMemo(() => ({source: items, filtered: filteredItems, setFiltered: setFilteredItems}), [items, filteredItems, setFilteredItems]);

	return (
		<FilteredItemsContext.Provider value={value}>
			{children}
		</FilteredItemsContext.Provider>
	);
}

export function useFilteredItems<T>() {
	const context = useContext(FilteredItemsContext);
	if (!context) {
		throw new Error("useFilter must be used within a FilteredItemsContext");
	}
	return context as FilteredItemsContextType<T>;
}
